import autoTable from "jspdf-autotable";

/* =========================
   COMMON HEADER
========================= */
const drawHeader = (doc) => {
  // LOGO (LEFT)
  try {
    doc.addImage(
      `${window.location.origin}/logo192.png`,
      "PNG",
      40,
      30,
      95,
      45
    );
  } catch {}

  // COMPANY INFO (RIGHT)
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text("Serena Beds Limited", 555, 40, { align: "right" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Unit 2, Ashbourne Business Centre", 555, 58, { align: "right" });
  doc.text("Ashbourne, Meath, A84 R960", 555, 70, { align: "right" });
  doc.text("Ireland", 555, 82, { align: "right" });
  doc.text("www.serenabeds.ie | sales@serenabeds.ie", 555, 96, {
    align: "right",
  });

  doc.setDrawColor(210);
  doc.line(40, 110, 555, 110);
};


/* =========================
   FOOTER NOTES
========================= */
const drawFooterNotes = (doc) => {
  const pageHeight = doc.internal.pageSize.height;

  doc.setFontSize(8);
  doc.setTextColor(120);
  doc.text(
    "Thank you for choosing Serena Beds - Your premium bedding partner",
    300,
    pageHeight - 40,
    { align: "center" }
  );
  doc.text(
    "All goods remain the property of Serena Beds Limited until paid in full",
    300,
    pageHeight - 28,
    { align: "center" }
  );
  doc.setTextColor(0);
};

/* =========================
   SINGLE ORDER DOCKET
========================= */
export const drawDocket = (doc, order) => {
  drawHeader(doc);

  // Meta
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Date:", 40, 130);
  doc.text(new Date().toLocaleDateString(), 90, 130);

  doc.text("Invoice:", 420, 150, { align: "right" });
  doc.text(order.id || "-", 420, 165, { align: "right" });


  // Items table
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 14,
    head: [["Category", "Size", "Description", "Qty"]],
    body: [[
      order.category || "Bed",
      order.size || "-",
      `${order.product_name || "-"}${
        order.urgentReason ? `\nURGENT: ${order.urgentReason}` : ""
      }`,
      order.quantity || 1
    ]],
    theme: "grid",
    styles: { fontSize: 9 },
    headStyles: { fillColor: [235, 242, 247] }
  });

  // Signatures
  const y = doc.lastAutoTable.finalY + 30;
  doc.rect(40, y, 220, 60);
  doc.text("Customer / Received By", 50, y + 18);

  doc.rect(300, y, 220, 60);
  doc.text("Driver / Dispatch", 310, y + 18);

  drawFooterNotes(doc);
};

/* =========================
   MULTIPLE ORDERS (GROUPED)
========================= */
export const drawCustomerDocket = (doc, orders) => {
  drawHeader(doc);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("Date:", 40, 130);
  doc.text(new Date().toLocaleDateString(), 90, 130);

  const rows = orders.map(o => ([
    o.category || "Bed",
    o.size || "-",
    `${o.product_name || "-"}${
      o.urgentReason ? `\nURGENT: ${o.urgentReason}` : ""
    }`,
    o.quantity || 1
  ]));

  autoTable(doc, {
    startY: 190,
    head: [["Category", "Size", "Description", "Qty"]],
    body: rows,
    theme: "grid",
    styles: {
      fontSize: 9,
      cellPadding: 6,
      overflow: "linebreak"
    },
    headStyles: {
      fillColor: [235, 242, 247],
      textColor: 20,
      fontStyle: "bold",
      lineWidth: 0.5
    },
    columnStyles: {
      0: { cellWidth: 70 },
      1: { cellWidth: 80 },
      2: { cellWidth: 285 },
      3: { cellWidth: 60, halign: "center" }
    }
  });

  const y = doc.lastAutoTable.finalY + 30;
  doc.rect(40, y, 220, 60);
  doc.text("Customer / Received By", 50, y + 18);

  doc.rect(300, y, 220, 60);
  doc.text("Driver / Dispatch", 310, y + 18);

  drawFooterNotes(doc);
};

